// extracted by mini-css-extract-plugin
export default {"btn":"CommonPopup__btn--X0f"};